import { Vector3 } from 'three';
import Entity, { IEntity } from '../abstract/Entity';
import { ISpace } from './SpaceModel';

export interface ICameraPositionSprite extends IEntity {
  id: number;
  position: Vector3;
  spaceUuid: string | null;
}

class CameraPositionSpriteModel extends Entity implements ICameraPositionSprite {
  id: number;
  position: Vector3;

  spaceUuid: string | null;

  constructor(id: number, position: Vector3, spaceOrUuid: ISpace | string | null = null) {
    super();
    this.id = id;
    this.position = position;

    if (typeof spaceOrUuid === 'string') {
      this.spaceUuid = spaceOrUuid;
    } else {
      this.spaceUuid = spaceOrUuid?.uuid ?? null;
    }
  }

  toJSON() {
    return {
      ...super.toJSON(),
      id: this.id,
      position: { x: this.position.x, y: this.position.y, z: this.position.z },
      spaceUuid: this.spaceUuid ?? null,
    };
  }
}

export default CameraPositionSpriteModel;
